import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    obtemTextoArray,
} from '../../../business-components/Array/Array'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    trataValorTexto,
    trataPercentualTexto,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiPosicaoInvestimentos,
} from './IntegracaoClienteArquivoService'



export const importaPosicaoInvestimentosIonItau = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    //PDFTxt = PDFTxt.replaceAll('\u0000', 'a')
    PDFTxt = PDFTxt.replaceAll('R$ ', 'R$')
    PDFTxt = PDFTxt.replaceAll('Fundo de Investimento', 'Fundo-de-Investimento')
    PDFTxt = PDFTxt.replaceAll('CDB, Renda Fixa e Inv. Estruturados', 'CDB,-Renda-Fixa-e-Inv.-Estruturados')
    PDFTxt = PDFTxt.replaceAll('Renda Fixa Ativo', 'Renda-Fixa-Ativo')
    PDFTxt = PDFTxt.replaceAll('Alternativos Líquidos', 'Alternativos-Líquidos')
    PDFTxt = PDFTxt.replaceAll('Renda Variável', 'Renda-Variável')
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Ativos Saldo bruto' + fimLinha + '(R$)' + fimLinha + 'Saldo líquido' + fimLinha +
        '(R$)' + fimLinha + 'Alocação Data de' + fimLinha + 'aplicação' + fimLinha + 'Taxa' +
            fimLinha + 'contratada' + fimLinha + 'Data de' + fimLinha + 'venc.' + fimLinha +
                'Rentabilidade (%)' + fimLinha + 'Rent.' + espaco,
                    fimLinha + 'Ativos Saldo bruto (R$) Saldo líquido (R$) Alocação Data de aplicação Taxa contratada Data de venc. Rentabilidade (%) Rent.'+
                        espaco)
    //console.log(PDFTxt)



    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira = HARDCODE.idInstituicaoFinanceiraIonItau

    
    obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + */'Posição de Investimentos' + fimLinha, fimLinha,
        HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)
    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta =
        jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta.replace('AG ', '')
    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta =
        jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta.replace(' / CC ', '/')
    
    //////obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Patrimônio líquido' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoPatrimonioTotalBruto, true, null, erros, nomeArquivo)

    //////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade no mês foi de' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoRentabilidadeMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO MÊS:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanhoMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO DESDE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Positivos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesPositivos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Negativos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesNegativos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + 'Relatório de Investimentos */espaco + 'Data de referência:' + espaco, fimLinha,
    ////    HARDCODE.importacaoDataReferencia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Í N D I C E S  D E  R E F E R Ê N C I A' + fimLinha +
    //    'Benchmarks Mês Atual Ano 12M 24M' + fimLinha + 'CDI' + espaco, fimLinha,
    //        HARDCODE.importacaoTaxaCDI12Meses, true, null, erros, nomeArquivo)
    
    //jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses =
    //    trataPercentualTexto(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses.split(espaco)[2])
    
    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Rent. 12 meses Rent. Desde o início' + fimLinha,
        fimLinha + 'Notas Explicativas' + espaco,
            HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)

    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos)

    const linhasPosicaoInvestimentosATratar =
        jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
    let indexLinhasPosicaoInvestimentosATratar

    const linhasPosicaoInvestimentos = []
    let indexLinhasPosicaoInvestimentos

    const posicaoInvestimentos = []

    let posFinalDescricao
    let descricao
    let tipoRecursoFinanceiro
    let valor
    //let percRentabilidadeAnualRecursoFinanceiro
    let dataInicioRecursoFinanceiro = null
    let percRentabilidadeMesRecursoFinanceiro
    let percCDIMesRecursoFinanceiro
    let percRentabilidadeAnoRecursoFinanceiro
    let percCDIAnoRecursoFinanceiro
    let percRentabilidade12MRecursoFinanceiro
    let percCDI12MRecursoFinanceiro
    let percRentabilidade24MRecursoFinanceiro
    let percCDI24MRecursoFinanceiro
    let vencimento = null

    let dadosPosicaoInvestimentos

    indexLinhasPosicaoInvestimentosATratar = 0

    while (indexLinhasPosicaoInvestimentosATratar < linhasPosicaoInvestimentosATratar.length - 1) {

        if (
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('INFORMAÇÃO CONFIDENCIAL RESTRITA POLÍTICA DE SEGURANÇA INTERNA') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf(' / CC ') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('DETALHAMENTO DE ATIVOS') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('DATA DA POSIÇÃO: ') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('DATA DA RENTABILIDADE: ') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('RENTAB. SIMULADA ') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('ATIVOS SALDO ATUAL (R$) ALOCAÇÃO DATA INÍCIO DATA VENCIMENTO') === -1 &&
                linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                    .indexOf('ATIVOS SALDO BRUTO (R$) SALDO LÍQUIDO (R$) ALOCAÇÃO DATA DE APLICAÇÃO TAXA CONTRATADA DATA DE VENC. RENTABILIDADE (%) RENT.') === -1
        ) {
            
            if (
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                        [linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].length - 1] === '%' ||
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 2) === 'R$' ||
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar].substring(0, 3) === '-R$' ||
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar] === '-' ||
                    (
                        indexLinhasPosicaoInvestimentosATratar > 0 &&
                        linhasPosicaoInvestimentos[linhasPosicaoInvestimentos.length - 1].indexOf('-') === -1 &&
                        linhasPosicaoInvestimentos[linhasPosicaoInvestimentos.length - 1].indexOf('/') === -1
                    )
            ) {

            linhasPosicaoInvestimentos[linhasPosicaoInvestimentos.length - 1] +=
                espaco + linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]

            } else {
                
                linhasPosicaoInvestimentos.push(
                    linhasPosicaoInvestimentosATratar[indexLinhasPosicaoInvestimentosATratar]
                )
            }
        }

        indexLinhasPosicaoInvestimentosATratar++
    }
    //console.log(linhasPosicaoInvestimentos)

    indexLinhasPosicaoInvestimentos = 0

    let modelo

    if (PDFTxt.indexOf('Ativos Saldo bruto') === -1) {

        modelo = 1

    } else {

        modelo = 2
    }

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {
        //console.log(linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos])

        const tipoRecursoFinanceiroAux = pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)[0]).idConversao

        if (tipoRecursoFinanceiroAux) {

            tipoRecursoFinanceiro = tipoRecursoFinanceiroAux

        } else {

            dadosPosicaoInvestimentos = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)

            let ajuste = 0
            let ajuste2 = 0

            if (modelo === 2) {

                ajuste = 2
                ajuste2 = 1
            }

            posFinalDescricao = dadosPosicaoInvestimentos.length - 17 - ajuste

            descricao = obtemTextoArray(dadosPosicaoInvestimentos, 0, posFinalDescricao)

            valor = trataValorTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 16 - ajuste])

            if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 16 - ajuste].indexOf('-') !== -1) {

                valor = valor * -1
            }

            if (valor === 0) {

                valor = '0.00'
            }

            dataInicioRecursoFinanceiro = trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 14 - ajuste2])
            percRentabilidadeMesRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 10])
            //percCDIMesRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[4])
            percRentabilidadeAnoRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 6])
            //percCDIAnoRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[6])
            percRentabilidade12MRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 4])
            //percCDI12MRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[8])
            //percRentabilidade24MRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[7])
            //percCDI24MRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[8])
            vencimento = trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 13])

            //Não deu certo
            //percRentabilidadeAnualRecursoFinanceiro =
            //    round(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses *
            //        (trataPercentualTexto(dadosPosicaoInvestimentos[10]) / 100), 2)

            //Problema com conversão de taxas negativas
            //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3].indexOf('/')) {

            //    percRentabilidadeAnualRecursoFinanceiro =
            //        converteTaxaMensalEmAnual(
            //            converteTaxaEmMensal(
            //                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2]),
            //                    calculaMeses2Datas(trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3]),
            //                        somaMesesData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataReferencia, -1)
            //                    )
            //            )
            //        )
            //}

            incluiPosicaoInvestimentos(posicaoInvestimentos, tipoRecursoFinanceiro, descricao,
                valor/*, percRentabilidadeAnualRecursoFinanceiro*/, jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                    dataInicioRecursoFinanceiro, percRentabilidadeMesRecursoFinanceiro, percCDIMesRecursoFinanceiro,
                        percRentabilidadeAnoRecursoFinanceiro, percCDIAnoRecursoFinanceiro,
                            percRentabilidade12MRecursoFinanceiro, percCDI12MRecursoFinanceiro,
                                percRentabilidade24MRecursoFinanceiro, percCDI24MRecursoFinanceiro, vencimento)
        }

        indexLinhasPosicaoInvestimentos++
    }
   


    jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos = posicaoInvestimentos
    /*
    erros.push('teste'
        .replace("$numeroProposta$", 'xxx')
            .replace("$codigoAgente$", 'yyy')
    )
    console.log(jsonRegistros)
    */



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}